import { bonusActionsFromSlice } from '../reducers/bonus';

export const bonusActions = { bonus: bonusActionsFromSlice };
